import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  constructor(private api: ApiService) { }

  private host: string = environment.api.pub.host;

  public subscribe = async (request: object) => this.api.post(`${this.host}/contact/subscribe`, request, new HttpHeaders());
  public feedback = async (request: object) => this.api.post(`${this.host}/contact/submit`, request, new HttpHeaders());
  public template = async () => this.api.get(`${this.host}/contact/template`, new HttpHeaders());
  public templateGet = async (code: String) => this.api.get(`${this.host}/marketing/template/${code}`, new HttpHeaders());
  public user = async (code: String) => this.api.get(`${this.host}/contact/user/${code}`, new HttpHeaders());
  public cancelTransaction = async (request: string) => this.api.get(`https://payments.fevertreefinance.co.za/payfast/cancel/${request}`, new HttpHeaders());
}
